import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';

import { environment } from '../../../environments/environment';
import { AuthService } from '../../shared/service/auth.service';

@Component({
	selector: 'app-api-modal',
	templateUrl: './api-modal.component.html',
	styleUrls: ['./api-modal.component.css']
})
export class ApiModalComponent implements OnInit {
	@Output() saved = new EventEmitter<void>();

	display: boolean = false;
	ip: string;
	ipIsOk: boolean;
	testIp = false;
	errorMessage: string;
	successMessage: string;
	router: any;


	constructor(
		private authService: AuthService,
		private translateService: TranslateService,
	) {
		this.loadLanguages();
	}

	ngOnInit() {
	}

	onOpenModal() {
		this.ip = this.authService.getApiIP();
		this.ipIsOk = false;

		// if (this.ip.length > 0) {
		// 	this.testConnection();
		// }
	}

	onCloseModal() {
		this.display = false;
		this.saved.emit();
	}

	save() {
		environment.apiUrl = this.ip;
		this.authService.setApiIP(environment.apiUrl);
		this.onCloseModal();
	}

	testConnection() {
		if (!isNullOrUndefined(this.ip) && this.ip.length > 0) {
			this.testIp = true;
			this.authService.testConnection(this.ip).subscribe(res => {
				this.ipIsOk = true;
				this.testIp = false;
				this.successMessage = this.translate('api_success_message')
			}, err => {
				this.testIp = false;
				this.ipIsOk = false;
				this.errorMessage = this.translate('api_error_message')
			});
		}

		setTimeout(() => {
			this.errorMessage = '';
			this.successMessage = '';
		}, 5000);
	}

	changingLang: boolean = false;

    languages: any[] = [];

    selectedLang = null;

	onChangeLang = () => this.changingLang = !this.changingLang;

    changeLang(lang: string) {
        localStorage.setItem('language', lang);
        window.location.reload();
    }

    onLogout(){
        this.authService.setLogoutState();
        this.router.navigate(['/login']);
    }

	loadLanguages() {
        this.languages = [
            {
                label: 'Português',
                language: 'br',
                enabled: true
            },
            {
                label: 'English',
                language: 'en',
                enabled: true
            },
            // {
            //     label: 'Chinese',
            //     language: 'cc',
            //     enabled: false
            // }
        ];

        this.selectedLang = this.languages.find(
            (lang) => lang.language == (localStorage.getItem('language') || 'br')
        );
    }

	translate = (key: string) => this.translateService.instant(key || "invalid");
	tUpper = (key) => this.translate(key).toString().toUpperCase();
	tCap = (key) => this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/login/api-modal/api-modal.component.ts